import { findBy, H5, List, makeStyles } from '@perk-ui/core'

import { Patient } from '../features/query-hooks/usePatient'
import usePatientCases from '../features/query-hooks/usePatientCases'
import { SurveyResponseGroup } from '../features/query-hooks/useSurveyResponseGroups'
import PatientOpenSurvey from './PatientOpenSurvey'

export interface PatientOpenSurveysProps {
  openSurveys: SurveyResponseGroup[]
  patient?: Patient
  parentToggle?: () => void
}

const useStyles = makeStyles((theme) => ({
  cardTitle: {
    marginBottom: theme.spacing(2),
  },
}))

const PatientOpenSurveys: React.FC<PatientOpenSurveysProps> = ({
  openSurveys,
  patient,
  parentToggle,
}) => {
  const classes = useStyles()
  const { data: patientCases = [] } = usePatientCases(patient?.id || '')

  return (
    <>
      <H5 className={classes.cardTitle}>
        {openSurveys.length > 0 ? 'Open Surveys' : 'No Open Surveys'}
      </H5>
      <List>
        {openSurveys.map((openSurvey) => {
          const patientCase = findBy('id', openSurvey.firstCaseId, patientCases)
          return (
            <PatientOpenSurvey
              key={openSurvey.id}
              openSurvey={openSurvey}
              patient={patient}
              patientCase={patientCase}
              parentToggle={parentToggle}
            />
          )
        })}
        {openSurveys.length === 0 && (
          <span>
            No actions available because no surveys are currently open for this
            patient.
          </span>
        )}
      </List>
    </>
  )
}

export default PatientOpenSurveys
